<template>
  <div class="Fuell-Overlay">
    <div class="Fuell-Modal">
      <div class="Fuell-Modal--window small centered">
        <button
          class="Fuell-Modal--close-button"
          @click="closeModal"
        >
          <img
            :src="require('@/assets/img/icons/close.svg')"
            alt="close"
          >
        </button>
        <h3
          class="Fuell-Modal--title"
          v-t.preserve="{path: 'user_request_gross_salary_title'}"
        >
        </h3>
        <div class="Fuell-Modal--content">
          <p v-t.preserve="{path: 'user_request_gross_salary_message'}"></p>
          <div class="input--block input--block--margin input--block--padded my-3">
            <label class="form--label">{{$t('user_gross_salary').toUpperCase()}}</label>
            <div
              class="Form-field"
              :class="{'Form--field-error' : userGrossSalary < minimumSalary}"
            >
              <currency-input
                v-model="userGrossSalary"
                ref="salaryInput"
                class="Fuell-TableInput"
                :allowNegative="false"
                :placeholder="$t('user_gross_salary')"
                @focus="toggleKeyDown"
                @blur="toggleKeyDown"
              ></currency-input>
              <div class="Form-field--input-icon-container">
                <img
                  alt="check-icon"
                  :src="require('@/assets/img/icons/icon-check-blue.svg')"
                  v-if="!keyDownFlag"
                >
                <img
                  alt="edit-icon"
                  :src="require('@/assets/img/icons/icon-pencil-blue.svg')"
                  v-else
                >

              </div>
            </div>
            <small
              class="text-danger"
              v-if="userGrossSalary < minimumSalary"
            >
              {{$t('user_request_gross_salary_error_validation_message', {minimumSalary : $options.filters.currency(minimumSalary, '€', 2, {symbolOnLeft: false, thousandsSeparator: '.',decimalSeparator: ','})})}}

            </small>
          </div>
          <button
            class="Fuell-Button blue mt-3 px-4"
            @click="confirmChange"
            :disabled="userGrossSalary < minimumSalary"
            v-t.preserve="{path: 'ACTION_SEND'}"
          ></button>

        </div>
      </div>

    </div>

  </div>

</template>

<script>
import { CurrencyInput } from 'vue-currency-input'
import { MINIMUM_GROSS_SALARY_RET_FLEX } from '@/utils/constants'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import { validationMixin } from 'vuelidate'
import { minValue } from 'vuelidate/lib/validators'
export default {
  name: 'UserRequestGrossSalaryModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: {
    CurrencyInput
  },
  props: {
    featureData: {
      type: Object
    }
  },
  computed: {
    features () {
      return this.$store.getters['ConfigStore/privateConfig'].user_features
    },
    minimumSalary () {
      return MINIMUM_GROSS_SALARY_RET_FLEX
    }
  },
  data () {
    return {
      userGrossSalary: 0,
      keyDownFlag: true,
      minimal: this.minimumSalary

    }
  },
  validations: {
    userGrossSalary: {
      minValue: minValue('minimumSalary')
    }
  },
  mounted () {
    this.$refs.salaryInput.$el.focus()
    this.$refs.salaryInput.$el.select()
  },
  methods: {
    toggleKeyDown () {
      this.$v.$touch()
      this.keyDownFlag = !this.keyDownFlag
    },
    async confirmChange () {
      let { id } = this.features.find(el => el.code === this.featureData.featureRequested)
      let updateInformation = {
        activatedFeatures: [{ feature: { id: id } }],
        grossSalary: this.userGrossSalary,
        id: this.featureData.userId

      }
      try {
        await this.$store.dispatch('UsersStore/updateUser', updateInformation)
        this.$emit('syncUserFeatureActivated', true)
        this.closeModal()
      } catch (error) {
        this.$emit('syncUserFeatureActivated', false)
      }
    }
  }

}
</script>

<style scoped>
.Fuell-Modal--content {
  padding: 10px 5px;
}
.Fuell-Modal--content > p {
  font-size: 1rem;
}
.Fuell-Modal--window {
  padding: 14px 24px;
}
.Fuell-TableInput {
  background-color: var(--fill-background);
}
.Form-field {
  position: relative;
}
.Form-field--input-icon-container {
  position: absolute;
  right: 15px;
  bottom: 15px;
}
.small {
  max-width: 500px;
}
</style>
